import { SearchMdIcon as e } from "../icons/SearchMdIcon.js";
import { AlertCircleIcon as t } from "../icons/AlertCircleIcon.js";
import { FeedbackActionControl as n } from "../feedback/FeedbackAction.js";
import { CheckCircleIcon as r } from "../icons/CheckCircleIcon.js";
import { FilePlus02Icon as i } from "../icons/FilePlus02Icon.js";
import { Lock01Icon as a } from "../icons/Lock01Icon.js";
import { jsx as o, jsxs as s } from "react/jsx-runtime";
import c from "clsx";
//#region src/components/empty-state/EmptyState.tsx
var l = {
	"first-use": i,
	"no-results": e,
	"all-done": r,
	"no-access": a,
	error: t
}, u = ({ kind: e, title: t, description: r, size: i = "section", headingLevel: a = 3, primaryAction: u, secondaryAction: d, referenceId: f, className: p }) => {
	let m = l[e], h = a === 2 ? "h2" : a === 4 ? "h4" : "h3";
	return /* @__PURE__ */ s("div", {
		className: c("pf:box-border pf:flex pf:w-full pf:min-w-0 pf:flex-col pf:items-center pf:justify-center pf:gap-lg pf:px-[24px] pf:text-center pf:font-body pf:wrap-anywhere", i === "page" ? "pf:h-full pf:py-[64px]" : "pf:py-[32px]", p),
		children: [
			/* @__PURE__ */ o(m, { size: 24 }),
			/* @__PURE__ */ s("div", {
				className: "pf:flex pf:w-full pf:max-w-[400px] pf:flex-col pf:gap-xs",
				children: [/* @__PURE__ */ o(h, {
					className: "pf:m-0 pf:text-heading-15 pf:text-soft-pearl-1000",
					children: t
				}), r && /* @__PURE__ */ o("p", {
					className: "pf:m-0 pf:text-copy-13 pf:text-soft-pearl-900",
					children: r
				})]
			}),
			(u || d) && /* @__PURE__ */ s("div", {
				className: "pf:flex pf:max-w-full pf:flex-wrap pf:justify-center pf:gap-md pf:pt-xs",
				children: [u && /* @__PURE__ */ o(n, {
					action: u,
					variant: e === "first-use" ? "primary" : "secondary"
				}), d && /* @__PURE__ */ o(n, {
					action: d,
					variant: "secondary"
				})]
			}),
			f && /* @__PURE__ */ s("p", {
				className: "pf:m-0 pf:text-copy-12 pf:text-soft-pearl-800",
				children: ["Reference: ", f]
			})
		]
	});
};
//#endregion
export { u as EmptyState };
